import { COLOR, textStyles } from '@cosuno/cosuno-ui';
import styled from 'styled-components';

import { zIndexValues } from '~/shared/utils/styles';

export const Bar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 88px;
  background-color: ${COLOR.danger};
  padding: 24px;
  z-index: ${zIndexValues.overdueInvoiceWarningBar};
  gap: 10px;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.2);
`;

export const Message = styled.div`
  ${textStyles.labelLarge500};
  color: ${COLOR.white};
`;
